import BackgroundImage from "../../components/ui/BackgroundImage";
import ProposalDocument from "./components/ProposalDocument";
import bgImg from "./assets/images/bg.webp";

export default () => {
  return (
    <BackgroundImage
      imageSrc={bgImg}
      className="h-screen flex items-center justify-center overflow-hidden"
    >
      <ProposalDocument
        title="Proposal"
        subtitle="ATLANTIS"
        description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        priestName="Ernesto"
        priestLabel="Preotul"
        cancelButtonText="Cancel"
        onAccept={() => alert("accept")}
        onCancel={() => alert("close")}
      />
    </BackgroundImage>
  );
};
